import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Issue from './Issue';
const GeneratedFilesBanner = (props) => {
    const { commitIssues } = props;
    return _jsx("div", { className: "commit-issues mt-4", children: commitIssues?.map((report) => (report.issues || []).map((issue) => (_jsx(Issue, { className: "commit-issues__item", issue: issue }, issue.ruleId)))) });
};
export default GeneratedFilesBanner;
